import Notification from '../../components/Notification/Notification';
import responseCodes from '../../constants/responseCodes';
import i18n from '../../i18n';
import { getSkillsService } from '../../services/skillsService';
import globalActionConstants from '../constants/globalActionConstants';
import skillsActionConstants from '../constants/skillsActionConstants';

const t = (key) => i18n.t(key, { ns: 'common' });

export const getSkills =
  (organizationId = null) =>
  async (dispatch) => {
    dispatch({ type: globalActionConstants.SET_LOADING_ON });
    try {
      const response = await getSkillsService(organizationId);
      if (response.data.response_code === responseCodes.OK) {
        dispatch({
          type: skillsActionConstants.GET_SKILLS,
          payload: response.data.payload,
        });
      } else {
        Notification.error(response.data.error);
      }
    } catch (err) {
      Notification.error(t('notifications.somethingWentWrong'));
    } finally {
      dispatch({ type: globalActionConstants.SET_LOADING_OFF });
    }
  };

export const loadOptions = (searchText, callback) => {
  const parameters = `${encodeURIComponent(searchText)}`;
  getSkillsService(null, parameters)
    .then((response) => {
      if (response.data.response_code === responseCodes.OK) {
        return callback(response.data.payload.skills);
      }

      Notification.error(response.data.error);
    })
    .catch(() => {
      Notification.error(t('notifications.somethingWentWrong'));
    });
};
